document.querySelectorAll(".block_faq_wrapper").forEach(function (section) {
    var faqHeadings = section.querySelectorAll(".block_faq__heading");
    faqHeadings.forEach(function (heading) {
      heading.addEventListener("click", function () {
        if (heading.classList.contains("active")) {
          heading.nextElementSibling.style.display = "none";
          heading.classList.remove("active");
        } else {
          section
            .querySelectorAll(".block_faq_info")
            .forEach(function (info) {
              info.style.display = "none";
            });
          section
            .querySelectorAll(".block_faq__heading")
            .forEach(function (h) {
              h.classList.remove("active");
            });
          heading.nextElementSibling.style.display = "block";
          heading.classList.add("active");
        }
      });
    });
  });